import { render, staticRenderFns } from "./PmToDosFilters.vue?vue&type=template&id=60b275eb&scoped=true&"
import script from "./PmToDosFilters.vue?vue&type=script&lang=ts&"
export * from "./PmToDosFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b275eb",
  null
  
)

export default component.exports